<template>
  <div class="activityMinPage">
    <div v-if="activityPic">
      <div v-if="activityPic.isShowPageActivity">
        <van-image width="100%"
                   fit="contain"
                   :src="activityPic.picChildUrl"></van-image>
      </div>
      <div v-else
           class="index-empty">
        <van-empty description="店家正在努力上新中~" />
      </div>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Image,
  Popup,
  Loading,
  Empty,
  Lazyload, overlay
} from "vant";
import loading from "../../components/loading/loading";
import { mapGetters } from "vuex";
export default {
  components: {
    [Image.name]: Image,
    [Popup.name]: Popup,
    [Loading.name]: Loading,
    [Empty.name]: Empty,
    [Lazyload.name]: Lazyload,
    [overlay.name]: overlay,
    loading
  },
  data () {
    return {
      imageUrl: "",
      isLoading: true, //loading状态
    };
  },
  computed: {
    ...mapGetters(["activityPic", "agentShow"])
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      setTimeout(() => {
        this.isLoading = false;
      }, 600);
    }
  }
};
</script>
<style scoped>
.activityMinPage {
  background: #fff;
}
</style>
